import { render, staticRenderFns } from "./HospitalChart.vue?vue&type=template&id=4ef3c7bd&"
import script from "./HospitalChart.vue?vue&type=script&lang=js&"
export * from "./HospitalChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports